import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * CLOUDWEB-18470 Промо загрузки десктоп приложения в сайдбаре
 */
export const promoDestopApp = getFeature('promo-desktop-app');
